import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './edit-store-url.html';
import { MySiteApp } from '../../my-site-app';
import { MySiteRestService } from '@nuskin/my-site-api';
import { nuskin } from '@nuskin/ns-util'

/**
 * @customElement
 * @polymer
 */
export class EditStoreUrl extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
    
        // must be present for form-wrapper to do validation and form save
        this.parentNode.saveForm = this.save();
        this.formFields = [];
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'edit-store-url';
    }

    static get properties() {
        return {
            subdomainIsBlacklisted: {
                type: Boolean,
                observer: '_handleError'
            },
            subdomainIsNotAvailable: {
                type: Boolean,
                observer: '_handleError'
            }
        }
    }

    connectedCallback(){
        super.connectedCallback();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    
        this.formFields = [
            this.$.storeUrl
        ];
    }

    _handleError(error) {
        this.$.successIcon.className = error ? 'hide' : ''
        this.$.errorIcon.className = error ? '' : 'hide'
    }

    disconnectedCallback(){
        super.disconnectedCallback();
        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    }

    _subscribeToMySiteDataChanges(){
        this.set('data', this.mySite.mySiteData)
        if(this.mySite.currentForm !== EditStoreUrl.is) return;
        this.set('data',this.mySite.mySiteData);
        this.set('subdomain', Object.keys(this.data.storefront)[0]);
        this.set('url', `https://${this.subdomain}.${this.content.welcomePage1SiteDomain}`)
    }

    _handleStoreUrl(e) {
        this.parentNode.setFormValidity(false);
        let value = e.target.value.replace(/[^a-zA-Z0-9]/g,'').toLowerCase();
        if(!value) return;
        this.subdomain = value.substring(0,50);
        this.$.storeUrl.valid = false;
        this.parentNode.formTouched();
        clearTimeout(this.subdomainCheckDebounce);
        this.set('url', `https://${this.subdomain}.${this.content.welcomePage1SiteDomain}`);
        // debounce check by 700ms
        this.subdomainCheckDebounce = setTimeout(() => {
            MySiteRestService.isSubdomainBlacklisted(value).then((isBlacklisted) => {
                this.subdomainIsBlacklisted = isBlacklisted;

                if(!this.subdomainIsBlacklisted) {
                    MySiteRestService.isSubdomainAvailable(value).then((isAvailable) => {
                        this.subdomainIsNotAvailable = !isAvailable;

                        if(this.subdomainIsNotAvailable) {
                            this.manipulateStoreUrlFieldValidity(this.content.welcomeStoreUrlAlreadyExist, '@#@#');
                            // GA
                            try {
                                nuskin.events.publish(nuskin.events.mySite.URL_EDIT_ALERTS, {
                                    mySite: {
                                        form: 'sidebar edit url from',
                                        attemptedSubdomain: value,
                                        errorType: 'not available'
                                    }
                                });
                            } catch(err) {console.log(err)}
                        } else {
                            // store url is valid
                            this.manipulateStoreUrlFieldValidity('', '');
                        }
                        this.parentNode.setFormValidity(!this.subdomainIsBlacklisted && !this.subdomainIsNotAvailable);
                    });
                } else {
                    this.manipulateStoreUrlFieldValidity(this.content.welcomeStoreUrlBlacklisted, '@#@#');
                    // GA
                    try {
                        nuskin.events.publish(nuskin.events.mySite.URL_EDIT_ALERTS, {
                            mySite: {
                                form: 'sidebar edit url from',
                                attemptedSubdomain: value,
                                errorType: 'blacklisted'
                            }
                        });
                    } catch(err) {console.log(err)}
                }
            });
        }, 700);
    }

    manipulateStoreUrlFieldValidity(message, regex) {
        this.$.storeUrl.invalidMessage = message;
        // this regex serves a purpose of invalidating the field when `.validate()` is triggered on storeUrl field.
        // It is done to handle blacklisted/taken sub-domain and prevent form from submitting
        this.$.storeUrl.regexValidation = regex;
        this.$.storeUrl.validate();
    }

    save() {
        let that = this;
        return function() {
            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: EditStoreUrl.is,
                        changed: that.subdomain
                    }
                });
            } catch(err) {console.log(err)}
            that.subdomainIsBlacklisted = undefined
            that.subdomainIsBlacklisted = undefined
            that.$.successIcon.className = 'hide';
            that.$.errorIcon.className =  'hide';
            return MySiteRestService.changeSubdomain(that.subdomain);
        };
    }
}

window.customElements.define(EditStoreUrl.is, EditStoreUrl);
